import React from 'react';
import { motion } from 'framer-motion';
import './Contact.css';
import { contactData } from '../../data/contactData';
import { BsFillEnvelopeFill } from 'react-icons/bs';
import { FaFacebookMessenger } from 'react-icons/fa';
import { ImWhatsapp } from 'react-icons/im';
import { useRef } from 'react';
import emailjs from 'emailjs-com';

const iconMap = {
  BsFillEnvelopeFill,
  FaFacebookMessenger,
  ImWhatsapp
};

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      contactData.form.emailjs.serviceId,
      contactData.form.emailjs.templateId,
      form.current,
      contactData.form.emailjs.publicKey
    );
    e.target.reset();
  };

  const getIconComponent = (iconName) => iconMap[iconName] || BsFillEnvelopeFill;

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.1 }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 32 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: 'spring', damping: 26, stiffness: 140 }
    }
  };

  const formStagger = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.08, delayChildren: 0.25 }
    }
  };

  const fieldItem = {
    hidden: { opacity: 0, y: 16 },
    show: { opacity: 1, y: 0 }
  };

  const spring = { type: 'spring', stiffness: 320, damping: 22 };

  return (
    <section id={contactData.header.id} className="contact-section">
      <motion.h5
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {contactData.header.subtitle}
      </motion.h5>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        {contactData.header.title}
      </motion.h2>

      <div className="container contactContainer">
        <motion.div
          className="contactOptions"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {contactData.options.map((option, index) => {
            const IconComponent = getIconComponent(option.icon, option.iconLibrary);
            return (
              <motion.a
                key={index}
                href={option.link}
                rel="noreferrer"
                target="_blank"
                className="contactOption"
                variants={item}
                whileHover={{ y: -10, scale: 1.03, transition: spring }}
                whileTap={{ scale: 0.98 }}
              >
                <motion.div
                  className="contactOptionIcon"
                  whileHover={{ rotate: [0, -8, 8, 0], transition: { duration: 0.4 } }}
                >
                  <IconComponent />
                </motion.div>
                <h4>{option.title}</h4>
                <h5>{option.subtitle}</h5>
                <span className="contactOptionCta">Send a Message</span>
              </motion.a>
            );
          })}
        </motion.div>

        <motion.form
          ref={form}
          onSubmit={sendEmail}
          className="contactForm"
          variants={formStagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {contactData.form.fields.map((field, index) =>
            field.type === 'textarea' ? (
              <motion.textarea
                key={index}
                name={field.name}
                rows={field.rows}
                placeholder={field.placeholder}
                required={field.required}
                className="formField formTextarea"
                variants={fieldItem}
              />
            ) : (
              <motion.input
                key={index}
                type={field.type}
                name={field.name}
                placeholder={field.placeholder}
                required={field.required}
                className="formField"
                variants={fieldItem}
              />
            )
          )}
          <motion.button
            type="submit"
            className="btn btn-primary formSubmit"
            variants={fieldItem}
            whileHover={{ scale: 1.04, y: -2 }}
            whileTap={{ scale: 0.97 }}
            transition={spring}
          >
            {contactData.form.submitText}
          </motion.button>
        </motion.form>
      </div>
    </section>
  );
};

export default Contact;
